import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { BrewersProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const BrewersList = Loader(lazy(() => import('../pages/Brewers')));

export const createBrewersRoutes = () => ({
  path: 'brewers',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['brewerViewAll']} should404>
          <Navigate to="/brewers/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['brewerViewAll']} should404>
          <BrewersProvider>
            <BrewersList />
          </BrewersProvider>
        </PermissionsGuard>
      )
    }
  ]
});
